<template>
  <tsl-card :cardList="cardList">
    <template v-slot:overview>
      <overview-card :cardList="overviewList" />
    </template>
  </tsl-card>
  <backup-statistics />
</template>

<script>
import Card from "@/components/tsl-card/index.vue";
import MyCard from "@/components/dashboard/devops/backup/overview/card";
import MyChart from "@/components/dashboard/devops/backup/overview/backup-statistics";
import { reactive } from "vue";

export default {
  name: "audit-overview",
  components: {
    [Card.name]: Card,
    [MyCard.name]: MyCard,
    [MyChart.name]: MyChart
  },
  setup() {
    const cardList = reactive([
      {
        name: "overview",
        title: "数据概览"
      }
    ]);

    const overviewList = reactive([
      {
        title: "备份计划",
        content: "56"
      },
      {
        title: "备份记录",
        content: "10"
      },
      {
        title: "备份文件",
        content: "300"
      },
      {
        title: "空间占用",
        content: "54.5GB/10T"
      }
    ]);

    return {
      cardList,
      overviewList
    };
  }
};
</script>

<style lang="less" scoped>
.card-container {
  height: 181px;
  div {
    margin-right: -16px;
  }
}
.content {
  color: #4e5969;
  font-weight: 400;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  line-height: 20px;
  text-align: left;
}
#backup-statistics {
  width: 100%;
  height: 400px;
  background: #fff;
}
</style>
